import { Button } from '@kizen/kds/Button';
import { Spacer } from '@kizen/kds/Spacer';
import { Typography } from '@kizen/kds/Typography';
import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Switch from '__components/Kizen/Switch';

type SetupFormProps = {
  onCancel: () => void;
  existingIds: string[];
};

export const SetupForm = (props: SetupFormProps) => {
  const { onCancel, existingIds } = props;
  const { t } = useTranslation();

  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState<string>();
  const [makePrimary, setMakePrimary] = useState(false);

  const handleSubmit = useCallback(
    async (event: React.FormEvent) => {
      event.preventDefault();
      setErrorMessage(undefined);

      // Stripe js hasn't been loaded yet
      if (!stripe || !elements) {
        return null;
      }

      const { error } = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: `${window.location.href}?success=true&makePrimary=${makePrimary}&existing=${existingIds.join(',')}`,
        },
      });

      if (error) {
        setErrorMessage(error.message);
      } else {
        // noop, redirect will happen automatically
      }
    },
    [stripe, elements, makePrimary, existingIds]
  );

  return (
    <form onSubmit={handleSubmit} className="kds pb-[10px]">
      {errorMessage ? (
        <>
          <Typography color="feedback-toast-error">{errorMessage}</Typography>
          <Spacer size={20} />
        </>
      ) : null}
      <div className="min-h-[173px]">
        <PaymentElement />
        <div className="pt-4">
          <Switch
            label={t('Make this the primary payment method')}
            textPlacement="regular-top"
            value="true"
            onChange={(e) => setMakePrimary(e.target.checked)}
            disabled={false}
            checked={makePrimary}
          />
        </div>
      </div>
      <Spacer size={20} />
      <div className="flex flex-col items-end">
        <div className="flex gap-10">
          <Button
            variant="text"
            color="warning"
            type="button"
            onClick={onCancel}
          >
            {t('Cancel')}
          </Button>
          <Button type="submit">{t('Save Payment')}</Button>
        </div>
      </div>
    </form>
  );
};
